<app-embedded-mobile-header *ngIf="isEmbedded"></app-embedded-mobile-header>
<p>
    The page you were looking for does not exist!
</p>
